import { SearchOutlined } from "@ant-design/icons";
import { Icon } from "@material-ui/core";
import { Button, Input, notification, Space } from "antd";
import axios from "axios";
import moment from "moment";
import { useCallback, useEffect, useRef, useState } from "react";
import Highlighter from "react-highlight-words";
import { FaSearch } from "react-icons/fa";
import { useHistory, useLocation } from "react-router";
import { urlConfigVersaoApp } from "../../../../../services/request/urls";
import { getToken } from "../../../../../services/token";


export interface IAlteracoes {
    titulo: string;
    descricao: string;
    icone?: string;
    imagem?: string;
    fileIcone?: string;
    fileImage?: string;
}

interface IAlteracoesResponse {
    id: number,
    uuid: string,
    numero: string,
    build_ios: number | null,
    build_android: number | null,
    alteracoes: string | null,
    alteracoes_json: string | null,
    dias_para_atualizar: number | null,
    created_at: string | null,
    updated_at: string | null
}

export default function useFormVersaoApp() {

    const formRef = useRef<any>(null);
    const location: any = useLocation();
    const history = useHistory();

    const { uuid } = location.state || {};

    const [loadingData, setLoadingData] = useState(false);
    const [loadingFormAdd, setLoadingFormAdd] = useState(false);

    const [valorDiasParaAtualizar, setValorDiasParaAtualizar] = useState('');
    const [valorBuildAndroid, setValorBuildAndroid] = useState('');
    const [valorBuildIos, setValorBuildIos] = useState('');
    const [valorNumero, setValorNumero] = useState('');
    const [oldAlteracoes, setOldAlteracoes] = useState<string | null>();
    const [alteracoes, setAlteracoes] = useState<IAlteracoes[]>([]);

    //State de editar usuario
    const [initialValueEditId, setInitialValueEditId] = useState<undefined | number>(undefined);

    //executa apenas ao iniciar o component
    useEffect(() => {
        setLoadingData(true)
        const buscaDeDados = async () => {
            try {
                let result = await axios.get(urlConfigVersaoApp, { headers: { 'Authorization': 'Bearer ' + getToken() } });

                const dataSelected: IAlteracoesResponse = result.data.filter((item: any) => item.uuid === uuid)[0];
                if (dataSelected) {
                    formRef.current?.setFieldsValue(dataSelected);
                    setAlteracoes(dataSelected.alteracoes_json ? JSON.parse(dataSelected.alteracoes_json) : []);
                    setOldAlteracoes(dataSelected.alteracoes);
                    setValorNumero(dataSelected.numero);
                    setInitialValueEditId(dataSelected.id);
                }

                setLoadingData(false)

            } catch (error) {

                let msgErro: any = (error as Error);

                setLoadingData(false)
                notification.error({
                    message: 'Erro',
                    description:
                        msgErro?.response?.data?.message ? msgErro?.response?.data?.message : 'Não foi possivel buscar os dados!',
                });
            }
        }

        buscaDeDados();

    }, [uuid]);


    const handleChangeAlteracoes = useCallback((alteracoes: IAlteracoes[]) => {
        setAlteracoes(alteracoes);

        alteracoes.length > 0 && formRef.current.setFieldsValue({ alteracoes_json: JSON.stringify(alteracoes) });
    }, [alteracoes]);


    // fim do search da tabela de listagem

    const clickSubmitVersionApp = useCallback((): void => {

        formRef.current?.validateFields()
            .then((values: any) => {
                setLoadingFormAdd(true);

                values.build_ios = parseFloat(values.build_ios)
                values.build_android = parseFloat(values.build_android)
                values.dias_para_atualizar = parseFloat(values.dias_para_atualizar)
                values.numero = values.numero

                if (initialValueEditId) {
                    values.id = initialValueEditId;
                    values.alteracoes_json = JSON.stringify(alteracoes);

                    const editarDadosModal = async () => {
                        try {
                            await axios.put(urlConfigVersaoApp, values,
                                { headers: { 'Authorization': 'Bearer ' + getToken() } });
                            notification.success({
                                message: 'Sucesso',
                                description:
                                    'Seus dados foram editados com sucesso!',
                            });
                            setLoadingFormAdd(false);
                            setInitialValueEditId(undefined);
                            history.goBack();
                        } catch (error) {
                            let msgErro: any = (error as Error);
                            setLoadingFormAdd(false);
                            notification.error({
                                message: 'Erro',
                                description:
                                    msgErro?.response?.data?.message ? msgErro?.response?.data?.message : 'Não foi possivel salvar, entre em contato com suporte!',
                            });
                        }
                    }
                    editarDadosModal();
                } else {
                    const salvarDadosModal = async () => {
                        try {

                            await axios.post(urlConfigVersaoApp, values,
                                { headers: { 'Authorization': 'Bearer ' + getToken() } });
                            notification.success({
                                message: 'Sucesso',
                                description:
                                    'Seus dados foram criados com sucesso!',
                            });
                            setLoadingFormAdd(false);
                            history.goBack();
                        } catch (error) {
                            let msgErro: any = (error as Error);
                            setLoadingFormAdd(false);
                            notification.error({
                                message: 'Erro',
                                description:
                                    msgErro?.response?.data?.message ? msgErro?.response?.data?.message : 'Não foi possivel salvar, entre em contato com suporte!',
                            });
                        }
                    }
                    salvarDadosModal();
                }

            })
            .catch((errorInfo: any) => {
                notification.error({
                    message: 'Erro',
                    description:
                        'Preencha os campos obrigatorios!',
                });
            });
    }, [initialValueEditId, alteracoes]);



    const onClickVoltarConfigOfSystem = useCallback((): void => {
        history.push("/configuracoesdosistema");
    }, []);

    const onClickVoltarListarVersaoApp = useCallback((): void => {
        history.push("/configuracoesdosistema/listarversaoapp");
    }, []);

    //Onchange inputs number
    const onChangeInputNumberDiasParaAtualizar = useCallback((e: any) => {
        const originalValue = e.target.value;//+''
        const regex = /^[0-9]*$/

        if (regex.test(originalValue)) {
            setValorDiasParaAtualizar(originalValue)
            formRef.current.setFieldsValue(
                { dias_para_atualizar: originalValue }
            );
        }
        else {
            formRef.current.setFieldsValue(
                { dias_para_atualizar: valorDiasParaAtualizar }
            );
        }
    }, [valorDiasParaAtualizar]);

    const onChangeInputNumberBuildAndroid = useCallback((e: any) => {
        const originalValue = e.target.value;//+''
        const regex = /^[0-9\.]*$/

        if (regex.test(originalValue)) {
            setValorBuildAndroid(originalValue)
            formRef.current.setFieldsValue(
                { build_android: originalValue }
            );
        }
        else {
            formRef.current.setFieldsValue(
                { build_android: valorBuildAndroid }
            );
        }
    }, [valorBuildAndroid]);

    const onChangeInputNumberBuildIos = useCallback((e: any) => {
        const originalValue = e.target.value;//+''
        const regex = /^[0-9\.]*$/

        if (regex.test(originalValue)) {
            setValorBuildIos(originalValue)
            formRef.current.setFieldsValue(
                { build_ios: originalValue }
            );
        }
        else {
            formRef.current.setFieldsValue(
                { build_ios: valorBuildIos }
            );
        }
    }, [valorBuildIos]);

    const onChangeInputNumberNumero = useCallback((e: any) => {
        const originalValue = e.target.value;//+''
        const regex = /^[0-9\.]*$/

        if (regex.test(originalValue)) {
            setValorNumero(originalValue)
            formRef.current.setFieldsValue(
                { numero: originalValue }
            );
        }
        else {
            formRef.current.setFieldsValue(
                { numero: valorNumero }
            );
        }
    }, [valorNumero]);



    return {
        onClickVoltarConfigOfSystem,
        onClickVoltarListarVersaoApp,
        initialValueEditId,
        loadingFormAdd,
        formRef,
        onChangeInputNumberNumero,
        onChangeInputNumberDiasParaAtualizar,
        onChangeInputNumberBuildIos,
        onChangeInputNumberBuildAndroid,
        oldAlteracoes,
        handleChangeAlteracoes,
        alteracoes,
        history,
        clickSubmitVersionApp,
        valorNumero
    }

}
